import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'
import { dateFormat } from 'app/appSettings'
import { CurrencyFormated } from 'app/views/common/Formats'
import parse from 'html-react-parser'
import moment from 'moment'

export function FormTextInputReadOnly ({
  value,
  elementType,
  typeProps,
  langVersion,
  editorPreview,
  ...props
}) {
  const { currency, isPhone, isAdvancedTextEditor } = typeProps
  let valueToShow = value
  if (elementType === 'textInputNumeric' && valueToShow) {
    if (isPhone) {
      valueToShow = '+1 ' + valueToShow
    } else if (currency) {
      valueToShow = <CurrencyFormated maximumFractionDigits={2} value={valueToShow} />
    }
  } else if (elementType === 'datePicker' && valueToShow) {
    valueToShow = moment(valueToShow).format(dateFormat)
  } else if (isAdvancedTextEditor || /<\/?[a-z][\s\S]*>/i.test(valueToShow)) {
    valueToShow = parse(value)
  }

  return (
    <div>
      <Typography className='form-read-only-text' sx={{ whiteSpace: 'pre-line' }}>
        {editorPreview ? <Trans>FIELD VALUE PLACEHOLDER</Trans> : valueToShow}
      </Typography>
    </div>
  )
}
